import { render, staticRenderFns } from "./columnChart.vue?vue&type=template&id=85fdd800&scoped=true&"
import script from "./columnChart.vue?vue&type=script&lang=js&"
export * from "./columnChart.vue?vue&type=script&lang=js&"
import style0 from "./columnChart.vue?vue&type=style&index=0&id=85fdd800&lang=scss&scoped=true&"
import style1 from "./columnChart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fdd800",
  null
  
)

export default component.exports